import Model from 'src/storage/base';

class VitalInfoModel extends Model {
  id = 'VitalInfoModel';
  defaultState = () => ({ vitalInfo: {} });
  persistent = false;
  apiConfig = {
    update: {
      url: 'profile/update/vital-info',
      validation: {
        vitalInfo: 'vitalInfo'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };

  handleProfile = ({ password, ...profile }) => {
    void password;
    this.setState({ ...profile, user: profile });
  };

  reset = () => {
    let user = this.state.user;
    this.resetApiState('update');

    this.setState({
      changed: false,
      vitalInfo: { ...user.vitalInfo }
    });
  };

  handleChangeVital = (n, v) => {
    const vitalInfo = { ...this.state.vitalInfo, [n]: v };
    this.handleChange('vitalInfo', vitalInfo);
    this.setState({ changed: true });
    this.resetApiState('updated');
  };

  save = () => {
    let req = {
      vitalInfo: this.state.vitalInfo
    };

    this.api('update', req, (error, data, success) => {
      if (success) {
        this.reset();
      }
    });
  };
}

const model = new VitalInfoModel();
export default model;
